import {Injectable} from '@angular/core';
import {ChannelApiService} from "../../api/channel-api.service";
import {Video} from "../../home/home-youtube/video.model";
import {MessageService} from "../../utils/message/message.service";

@Injectable({
  providedIn: 'root'
})
export class SuperAdminChannelService {

  constructor(
    private channelApi: ChannelApiService,
    private message: MessageService
  ) {
  }

  delete(video: Video) {
    if (video.id != null) {
      this.channelApi.delete(video).subscribe((response) => {
        if (response.success) {
          this.message.info("admin.channel.deleteSuccess");
        } else {
          this.message.error(response.httpError.message);
        }
      });
    }
  }

  saveUpdate(video: Video) {
    let edit = false;
    if (video.id != null) {
      edit = true;
    }

    if (edit) {
      /*this.channelApi.update(video).subscribe((response) => {
        if (response.success) {
          this.message.info("admin.channel.saveSuccess");
        } else {
          this.message.error(response.httpError.message);
        }
      });*/
      return this.channelApi.update(video);
    } else {
      return this.channelApi.save(video);
      /*this.channelApi.save(video).subscribe((response) => {
        if (response.success) {
          this.message.info("admin.channel.saveSuccess");
        } else {
          this.message.error(response.httpError.message);
        }
      });*/
    }
  }
}
